import {PollRobotTemplate} from './PollRobotTemplate.js';

export class OptionToggle extends HTMLElement {
	constructor() {
		super();
		this.shadow = this.attachShadow({mode:'open'});
		this.value = false;
	}
	connectedCallback() {
		[this.el, this.$] = PollRobotTemplate(`OptionToggle`);
		this.shadow.appendChild(this.el);
		let clickEvent = c => {
			c.addEventListener(`click`, evt=>{
				this.select(c.getAttribute(`data-item`));
			});
		};
		for (let c=this.shadow.firstElementChild; c; c=c.nextElementSibling) {
			clickEvent(c);
			if (c.hasAttribute(`selected`)) {
				c.classList.add(`selected`);
				this.value = c.getAttribute(`data-item`);
			}
		}
	}
	select(item) {
		this.value = item;
		for (let c = this.shadow.firstElementChild; c; c=c.nextElementSibling) {
			if (c.getAttribute(`data-item`)==item) {
				c.classList.add(`selected`);
			} else {
				c.classList.remove(`selected`);
			}
		}
	}

}

customElements.define(`option-toggle`, OptionToggle);